module.exports = __webpack_public_path__ + "static/kofi-ocran-seo-image-bca1598c5d173af6fef2a6337c9f39ba.png";